export default function requestSuccessFailureHelper(actionName, fn) {
  if (typeof actionName !== 'string') {
    throw new Error('actionName must be a string');
  }
  if (typeof fn !== 'function') {
    throw new Error('fn must be a function');
  }
  const actionNameUpper = actionName.toUpperCase();
  const actionRequest = `${actionNameUpper}_REQUEST`;
  const actionSuccess = `${actionNameUpper}_SUCCESS`;
  const actionFailure = `${actionNameUpper}_FAILURE`;

  const initialState = {
    data: null,
    loading: false,
    error: null
  };

  const reducer = (state = initialState, action) => {
    const actionPayload = action.payload || {};
    switch (action.type) {
    case actionRequest:
      return {
        ...state,
        loading: true
      };

    case actionSuccess:
      return {
        ...state,
        loading: false,
        data: actionPayload.data !== undefined ? actionPayload.data : null
      };

    case actionFailure:
      return {
        ...state,
        loading: false,
        error: actionPayload.error !== undefined ? actionPayload.error : null
      };

    default:
      return state;
    }
  };

  const action = (...args) => dispatch => {
    dispatch({
      type: actionRequest
    });
    try {
      const result = fn(...args);
      return result
        .then(response =>
          dispatch({
            type: actionSuccess,
            payload: {
              data: response.data
            }
          })
        )
        .catch(error =>
          dispatch({
            type: actionFailure,
            payload: {
              error
            }
          })
        );
    } catch (error) {
      dispatch({
        type: actionFailure,
        payload: {
          error
        }
      });
    }
    return new Promise();
  };

  return {
    action,
    actionTypes: {
      request: actionRequest,
      success: actionSuccess,
      failure: actionFailure
    },
    reducer
  };
}



// WEBPACK FOOTER //
// ./src/utils/helpers/ReduxHelper.js